import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type HouseProps = {
    className?: string;
};

const House: FunctionComponent<HouseProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'house'}
            viewBox="0 0 250 250"
        >
            <path d="M125-.8L0 124h37.7v126.8h174.6V124H250L125-.8zM97.4 245.8v-82.5h53v82.5h-53zm109.9 0h-51.9v-87.5h-63v87.5H42.7V124.7h164.6v121.1zM12.1 119L125 6.2 237.9 119H12.1z" />
        </svg>
    );
};
export default House;
